import React from 'react';
import {
    StyledContainer,
    StyledTimeText,
    StyledMessageContainer,
    StyledAvatar,
} from './ChatMessage.styles';
import { Box, Typography } from '../../../../base';
import { IServerJobApplicationChatMessage, formatMessageTime } from '../../../../common';

interface Props {
    messageData: IServerJobApplicationChatMessage;
    currentUserId?: number | string;
}

const ChatMessage = (props: Props) => {
    const { messageData, currentUserId } = props;
    const { user, message, created_at } = messageData;

    const fullName = `${user.first_name} ${user.last_name}`;
    const userImage = user.image;
    const isSender = currentUserId === user.id;

    const formattedTime = formatMessageTime(created_at);

    return (
        <StyledContainer container>
            <StyledAvatar name={fullName} src={userImage} />
            <Box sx={{ marginInlineStart: 1, lineHeight: 1.2, flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography component="span" sx={{ fontWeight: 'bold' }}>
                        {fullName}
                    </Typography>
                    <StyledTimeText variant="caption">
                        {formattedTime}
                    </StyledTimeText>
                </Box>
                <StyledMessageContainer isSender={isSender}>
                    <Typography variant="body2">{message}</Typography>
                </StyledMessageContainer>
            </Box>
        </StyledContainer>
    );
};

export default ChatMessage;
